export const communicationStorage = {
  testResults: [],
};
